import React, {Fragment, useContext, useEffect, useState} from 'react';
import {Button, Grid, List, ListItem, ListItemText, SvgIcon, Typography} from '@material-ui/core';
import {ErrorMessage, FieldArray, useFormikContext} from 'formik'
import {makeStyles} from "@material-ui/core/styles";
import Divider from '@material-ui/core/Divider';
import PopOverDetails from "../../../../../PopOverInfo";
import AffinityInfoContext from "../../../../../../context/AffinityContext";
import HikingIcon from "@mui/icons-material/Hiking";
import MedicalServicesIcon from "@mui/icons-material/MedicalServices";
import CallIcon from "@mui/icons-material/Call";
import RemoveIcon from "@mui/icons-material/Remove";
import AddIcon from "@mui/icons-material/Add";
import {CurrencyFormat} from "../../../../../utils/CurrencyFormat";
import MantineInputField from "../../../../FormikUtils/MantineInputField";
import MantineNumberField from "../../../../FormikUtils/MantineNumberField";

const useStyles = makeStyles((theme) => ({
    fieldArrayButtons: {
        padding: "0",
        marginTop: "16px",
        minWidth: "20px",
        maxWidth: "20px"
    },
    fieldArrayButtonsDiv: {
        display: "flex",
        flexDirection: "row",
        width: "48px",
        justifyContent: "space-between"
    },
    errorMessage: {
        color: "red",
        fontSize: "10px",
        textAlign: "center",
        marginTop: "4px"
    },
    declaracionTitle: {
        fontFamily: 'Montserrat',
        fontSize: 12,
        textAlign: "center"
    },
    note: {
        fontFamily: 'Nunito',
        fontSize: 12,
        textAlign: "center",
        marginLeft: "24px",
        marginRight: "24px",
        color: theme.palette.grey.A200
    },
    priceTitle: {
        fontFamily: 'EncodeSansRegular',
        fontSize: 18,
        color: "#fff"
    },
    priceText: {
        fontFamily: 'EncodeSansBold',
        fontSize: 32,
        color: "#fff"
    },
    boxPrice: {
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        width: "100%",
        height: "120px",
        backgroundColor: "#BB0D66"
    },
    coberturasTable: {
        padding: theme.spacing(1),
    },
    tableHeader: {
        fontFamily: 'EncodeSansBold',
        fontSize: 18
    },
    tableRowLabel: {
        fontFamily: 'EncodeSansRegular',
        fontSize: 14
    },
    dataText: {
        fontFamily: 'EncodeSansRegular',
        textAlign: "center",
        fontSize: 18
    },

}));

export default function SolicitudFormMobile(props) {
    const classes = useStyles();
    const {
        formField: {
            detalleEquipoElectronico: {
                descripcionElectronico,
                sumaAseguradaElectronico,
                codigoElectronico,
                codigoGrupoElectronico
            },
            detalleBicicletas: {
                descripcionBicicletas,
                sumaAseguradaBicicletas,
                codigoBicicletas,
                codigoGrupoBicicletas
            },
            detalleMonopatines: {
                descripcionMonopatines,
                sumaAseguradaMonopatines,
                codigoMonopatines,
                codigoGrupoMonopatines
            },
        },
        cotResponse
    } = props;
    const {coberturasInfo} = useContext(AffinityInfoContext);
    const {values, errors} = useFormikContext();
    const [sumasAseguradasDetails, setSumasAseguradasDetails] = useState(
        {bicicletas: 0, monopatines: 0, electronicos: 0}
    );
    const coberturasSinCosto = [
        {numeroCobertura: "44", icon: HikingIcon},
        {numeroCobertura: "45", icon: MedicalServicesIcon},
        {numeroCobertura: "50", icon: CallIcon}
    ]

    const equipoElectronicoVacio = {
        [descripcionElectronico.name]: '',
        [sumaAseguradaElectronico.name]: '',
        [codigoElectronico.name]: 201,
        [codigoGrupoElectronico.name]: 34,
    };
    const bicicletasVacio = {
        [descripcionBicicletas.name]: '',
        [sumaAseguradaBicicletas.name]: '',
        [codigoBicicletas.name]: 209,
        [codigoGrupoBicicletas.name]: 31,
    };
    const monopatinesVacio = {
        [descripcionMonopatines.name]: '',
        [sumaAseguradaMonopatines.name]: '',
        [codigoMonopatines.name]: 210,
        [codigoGrupoMonopatines.name]: 31,
    };

    const checkError = (prod) => {
        let prodName;
        if (prod === 1) prodName = "detalleBicicletas"
        if (prod === 2) prodName = "detalleMonopatines"
        if (prod === 3) prodName = "detalleEquipoElectronico"

        if (errors[prodName] !== undefined)
            return (errors[prodName].includes("Las sumas declaradas deben coincidir con las aseguradas"))
        else
            return false
    }

    useEffect(() => {
        Object.keys(values.coberturas).map(cob => {
            if (cob === "48") {
                let obj = sumasAseguradasDetails
                obj.bicicletas = values.coberturas[cob].sumaAsegurada
                setSumasAseguradasDetails(obj)
            }
            if (cob === "49") {
                let obj = sumasAseguradasDetails
                obj.monopatines = values.coberturas[cob].sumaAsegurada
                setSumasAseguradasDetails(obj)
            }
            if (cob === "26") {
                let obj = sumasAseguradasDetails
                obj.electronicos = values.coberturas[cob].sumaAsegurada
                setSumasAseguradasDetails(obj)
            }
        })
    }, []);

    const buttonsToShow = (index, length, arrayHelpers, emptyArray) => {
        if (length === 1) {
            return (<Grid item xs={2}>
                <Button variant='outlined' size="small"
                        style={{padding: "0", marginTop: "16px", minWidth: "48px", maxWidth: "48px"}}
                        onClick={() => arrayHelpers.push(emptyArray)}>
                    <AddIcon/>
                </Button>
            </Grid>)
        } else if (index !== length - 1) {
            return (<Grid item xs={2}>
                <Button variant='outlined' size="small"
                        style={{padding: "0", marginTop: "16px", minWidth: "48px", maxWidth: "48px"}}
                        onClick={() => arrayHelpers.remove(index)}>
                    <RemoveIcon/>
                </Button>
            </Grid>)
        } else {
            return (
                <Grid item xs={2}>
                    <div className={classes.fieldArrayButtonsDiv}>
                        <Button variant='outlined' size="small"
                                className={classes.fieldArrayButtons}
                                onClick={() => arrayHelpers.remove(index)}>
                            <RemoveIcon/>
                        </Button>
                        <Button variant='outlined' size="small"
                                className={classes.fieldArrayButtons}
                                onClick={() => arrayHelpers.push(emptyArray)}>
                            <AddIcon/>
                        </Button>
                    </div>
                </Grid>
            )
        }
    }

    return (
        <React.Fragment>
            <Grid container direction='column'>
                <Grid item container spacing={3} direction='column' className={classes.coberturasTable}>
                    <div style={{
                        display: "flex",
                        flexDirection: "row",
                        justifyContent: "space-between",
                        margin: "8px 24px",
                    }}>
                        <Typography className={classes.tableHeader}>Cobertura</Typography>
                        <Typography className={classes.tableHeader}>Suma Asegurada</Typography>
                    </div>

                    {Object.keys(values.coberturas).map(cobertura => {
                        if (values.coberturas[cobertura].selectedCobertura) {
                            return (
                                <Fragment>
                                    <div style={{
                                        display: "flex",
                                        flexDirection: "row",
                                        justifyContent: "space-between",
                                        alignItems: "center",
                                        margin: "4px 8px 4px 24px",
                                    }}>
                                        <div style={{width: "50%"}}>
                                            <Typography className={classes.tableRowLabel}>
                                                {coberturasInfo[cobertura].descripcion}
                                            </Typography>
                                        </div>
                                        <div style={{
                                            width: "30%", display: "flex",
                                            flexDirection: "row",
                                            justifyContent: "right",
                                        }}>
                                            <Typography
                                                className={classes.tableRowLabel}>$ {CurrencyFormat(parseInt(values.coberturas[cobertura].sumaAsegurada))}</Typography>
                                        </div>
                                        <div style={{width: "15%"}}>
                                            <PopOverDetails
                                                descripcion={coberturasInfo[cobertura].descripcionCompleta}
                                                isMobile={true}/>
                                        </div>
                                    </div>

                                    {cobertura === '48' &&
                                    <>
                                        <Typography className={classes.declaracionTitle}
                                                    style={{margin: "0px 16px 8px 16px"}}>
                                            Declaración de objetos asegurados bajo la cobertura "Robo de Bicicletas"
                                        </Typography>

                                        <div style={{
                                            display: "flex",
                                            flexDirection: "column",
                                            margin: "0 8px 16px 8px",
                                        }}>
                                            <FieldArray name='detalleBicicletas'>{(arrayHelpers) => (
                                                values.detalleBicicletas.map((item, index) => (
                                                    <Grid key={index} item container spacing={2} direction='row'
                                                          style={{alignItems: "center", justifyContent: "center"}}>
                                                        <Grid item xs={4}>
                                                            <MantineInputField
                                                                name={`detalleBicicletas[${index}].${descripcionBicicletas.name}`}
                                                                label={descripcionBicicletas.label}
                                                                withAsterisk
                                                                size="sm"
                                                                styles={{
                                                                    label: {fontSize: "12px", letterSpacing: "-0.5px"}
                                                                }}
                                                            />
                                                        </Grid>
                                                        <Grid item xs={4}>
                                                            <MantineNumberField
                                                                name={`detalleBicicletas[${index}].${sumaAseguradaBicicletas.name}`}
                                                                label={sumaAseguradaBicicletas.label}
                                                                styles={{
                                                                    input: {textAlign: "right", fontSize: "12px"},
                                                                    label: {fontSize: "12px", letterSpacing: "-0.5px"}
                                                                }}
                                                                size="sm"
                                                                withAsterisk
                                                            />
                                                        </Grid>

                                                        {buttonsToShow(index, values.detalleBicicletas.length, arrayHelpers, bicicletasVacio)}
                                                    </Grid>
                                                ))
                                            )}</FieldArray>
                                            {checkError(1)
                                            &&
                                            <>
                                                <ErrorMessage name='detalleBicicletas'
                                                              render={msg => <div
                                                                  className={classes.errorMessage}>{msg}</div>}/>
                                                <p className={classes.errorMessage}> ($ {sumasAseguradasDetails.bicicletas})</p>
                                            </>}
                                        </div>
                                    </>}

                                    {cobertura === '49' &&
                                    <>
                                        <Typography className={classes.declaracionTitle}
                                                    style={{margin: "0px 16px 8px 16px"}}>
                                            Declaración de objetos asegurados bajo la cobertura "Robo de Monopatines"
                                        </Typography>

                                        <div style={{
                                            display: "flex",
                                            flexDirection: "column",
                                            margin: "0 8px 16px 8px",
                                        }}>
                                            <FieldArray name='detalleMonopatines'>{(arrayHelpers) => (
                                                values.detalleMonopatines.map((item, index) => (
                                                    <Grid key={index} item container spacing={2} direction='row'
                                                          style={{alignItems: "center", justifyContent: "center"}}>
                                                        <Grid item xs={4}>
                                                            <MantineInputField
                                                                name={`detalleMonopatines[${index}].${descripcionMonopatines.name}`}
                                                                label={descripcionMonopatines.label}
                                                                withAsterisk
                                                                size="sm"
                                                                styles={{
                                                                    label: {fontSize: "12px", letterSpacing: "-0.5px"}
                                                                }}
                                                            />
                                                        </Grid>
                                                        <Grid item xs={4}>
                                                            <MantineNumberField
                                                                name={`detalleMonopatines[${index}].${sumaAseguradaMonopatines.name}`}
                                                                label={sumaAseguradaMonopatines.label}
                                                                styles={{
                                                                    input: {textAlign: "right", fontSize: "12px"},
                                                                    label: {fontSize: "12px", letterSpacing: "-0.5px"}
                                                                }}
                                                                size="sm"
                                                                withAsterisk
                                                            />
                                                        </Grid>

                                                        {buttonsToShow(index, values.detalleMonopatines.length, arrayHelpers, monopatinesVacio)}
                                                    </Grid>
                                                ))
                                            )}</FieldArray>
                                            {checkError(2)
                                            &&
                                            <>
                                                <ErrorMessage name='detalleMonopatines'
                                                              render={msg => <div
                                                                  className={classes.errorMessage}>{msg}</div>}/>
                                                <p className={classes.errorMessage}> ($ {sumasAseguradasDetails.monopatines})</p>
                                            </>}
                                        </div>
                                    </>}

                                    {cobertura === '26' &&
                                    <>
                                        <Typography className={classes.declaracionTitle}
                                                    style={{margin: "0px 16px 8px 16px"}}>
                                            Declaración de objetos asegurados bajo la cobertura "Robo de objetos
                                            varios"
                                        </Typography>

                                        <div style={{
                                            display: "flex",
                                            flexDirection: "column",
                                            margin: "0 8px 16px 8px",
                                        }}>
                                            <FieldArray name='detalleEquipoElectronico'>{(arrayHelpers) => (
                                                values.detalleEquipoElectronico.map((item, index) => (
                                                    <Grid key={index} item container spacing={2} direction='row'
                                                          style={{alignItems: "center", justifyContent: "center"}}>
                                                        <Grid item xs={4}>
                                                            <MantineInputField
                                                                name={`detalleEquipoElectronico[${index}].${descripcionElectronico.name}`}
                                                                label={descripcionElectronico.label}
                                                                withAsterisk
                                                                size="sm"
                                                                styles={{
                                                                    label: {fontSize: "12px", letterSpacing: "-0.5px"}
                                                                }}
                                                            />
                                                        </Grid>
                                                        <Grid item xs={4}>
                                                            <MantineNumberField
                                                                name={`detalleEquipoElectronico[${index}].${sumaAseguradaElectronico.name}`}
                                                                label={sumaAseguradaElectronico.label}
                                                                styles={{
                                                                    input: {textAlign: "right", fontSize: "12px"},
                                                                    label: {fontSize: "12px", letterSpacing: "-0.5px"}
                                                                }}
                                                                size="sm"
                                                                withAsterisk
                                                            />
                                                        </Grid>

                                                        {buttonsToShow(index, values.detalleEquipoElectronico.length, arrayHelpers, equipoElectronicoVacio)}
                                                    </Grid>
                                                ))
                                            )}</FieldArray>

                                            {checkError(3)
                                            &&
                                            <>
                                                <ErrorMessage name='detalleEquipoElectronico'
                                                              render={msg => <div
                                                                  className={classes.errorMessage}>{msg}</div>}/>
                                                <p className={classes.errorMessage}> ($ {sumasAseguradasDetails.electronicos})</p>
                                            </>}
                                        </div>
                                    </>}
                                    <Divider light style={{margin: "0px 16px"}}/>
                                </Fragment>
                            )
                        }
                    })}


                    <div style={{
                        display: "flex",
                        flexDirection: "column",
                        margin: "8px 24px",
                    }}>
                        <Typography className={classes.tableHeader}>Beneficios sin costo:</Typography>

                        <List dense>
                            {coberturasSinCosto.map((item, index) => (
                                <ListItem key={index}>
                                    <SvgIcon component={item.icon} fontSize="large"
                                             style={{marginRight: "16px", color: "#BB0D66"}}/>
                                    <ListItemText
                                        primary={coberturasInfo[item.numeroCobertura].descripcion}

                                    />
                                    {/*<p style={{fontFamily: 'sans-serif'}}> {dictCoberturas[item.numeroCobertura].descripcion} </p>*/}
                                </ListItem>
                            ))}
                        </List>
                    </div>

                    <Typography className={classes.note}>
                        Nota: si deseas modificar las coberturas seleccionadas debes realizar una nueva cotización
                        con las coberturas deseadas.
                    </Typography>
                    <Grid item/>

                </Grid>
                <div className={classes.boxPrice}>
                    <Typography className={classes.priceTitle}>Cuota mensual:</Typography>
                    <Typography className={classes.priceText}>$ {cotResponse.premioMensual}</Typography>
                </div>
            </Grid>
        </React.Fragment>
    );
}
